export const FIND_OPEN_PROCESS_STATEMENT_SUCCESS = 'FIND_OPEN_PROCESS_STATEMENT_SUCCESS';

export const findOpenProcessStatementSuccess = processStatement => ({
    type: FIND_OPEN_PROCESS_STATEMENT_SUCCESS,
    payload: { processStatement },
});
